module.exports = __webpack_public_path__ + "static/eldritch_adept-52b8ba58a8260365b0685a3656f20f7e.png";